import { moveToFulfilled, moveToPending, moveToRejected, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { SearchLoadAction, SearchLoadMoreFulfilledAction } from '../../domains/searches/actions.types';
import { Searches } from '../types';

export type SearchAction = SearchLoadAction | SearchLoadMoreFulfilledAction;

const initialState: Searches = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const appendMoreSearchResults = (state: Searches, action: SearchLoadMoreFulfilledAction) => {
  const { searchId, entities } = action.payload;
  const searchResult = entities.searchResults[searchId];

  const updatedSearchResults = {
    results: state.fulfilled.byId[searchId].results.concat(searchResult.results),
    hasNextPage: searchResult.hasNextPage,
    endCursor: searchResult.endCursor,
  };

  return update(state, searchId, updatedSearchResults);
};

const reducer: Reducer<Searches, SearchAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SEARCH.LOAD_PENDING':
      return moveToPending(state, [action.payload.searchId]);
    case 'SEARCH.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.searchResults);
    case 'SEARCH.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.searchId], action.payload.error);
    case 'SEARCH.LOAD_MORE_FULFILLED':
      return appendMoreSearchResults(state, action);
    default:
      return state;
  }
};

export default reducer;
